<template>
  <div class="userMain">
    <search-bar @fetchData="fetchData" @openTitleForm="handleAddBtn">
    </search-bar>
    <!-- 表单 -->
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      row-key="menuId"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      max-height="650"
    >
      <el-table-column align="center" width="100" label="序号">
        <template slot-scope="scope">
          <div>{{ scope.$index + 1 }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="功能名称">
        <template slot-scope="scope">
          <div>{{ scope.row.name }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="功能编码">
        <template slot-scope="scope">
          <div>{{ scope.row.operationCode }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="描述">
        <template slot-scope="scope">
          <div>{{ scope.row.operationDesc }}</div>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="路径">
        <template slot-scope="scope">
          <div>{{ scope.row.path }}</div>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="操作">
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="updateBtn(scope.row)"
            type="text"
            v-if="roleList[path].includes('_Update')"
            >编辑</el-button
          >
          <el-button
            size="small"
            @click="delBtn(scope.row)"
            type="text"
            v-if="roleList[path].includes('_Delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 表单 -->
    <EditForm ref="editForm" />
  </div>
</template>

<script>
import { getFunctionApi, delFunctionApi } from '@/api/user.js';
import EditForm from './components/editForm'; // 表单
import SearchBar from './components/searchBar';
import { mapGetters } from 'vuex';
export default {
  name: 'User',
  components: {
    EditForm,
    SearchBar,
  },
  data() {
    return {
      path: '',
      list: [],
      selectList: [],
      listLoading: false,
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
    this.fetchData();
  },
  methods: {
    async fetchData(obj = {}) {
      try {
        this.listLoading = true;
        let res = await getFunctionApi(obj);
        if (res.code !== 200) return;
        this.listLoading = false;
        this.list = res.data;
      } catch (e) {
        window.console.log(e);
      }
    },
    handleAddBtn() {
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.isEdit = false;
    },
    updateBtn(row) {
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.editForm = { ...row };
      this.$refs.editForm.isEdit = true;
    },

    delBtn(row) {
      this.$confirm('确认删除该菜单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const data = `operationId=${row.operationId}`;
          await delFunctionApi(data).then((res) => {
            if (res.code !== 200) return;
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            this.fetchData();
          });
        })
        .catch(() => {});
    },

    editBtn(row) {
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.isEdit = true;
      this.$refs.editForm.editForm = row;
    },
  },
};
</script>

<style lang="less" scoped>
.userMain {
  position: relative;
}

.addBtn {
  float: right;
  margin: 15px 0;
}

.table {
  height: 75vh;
  overflow: auto;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.lastBtn {
  margin-top: 10px;
}

.form_line1 {
  display: flex;
  // flex-direction: column;
}
</style>
